import assign from "./assets/assign.mp3";
import assign1 from "./assets/assign1.mp3";
import assign3 from "./assets/assign3.mp3";
import function0 from "./assets/function.mp3";
import function2 from "./assets/function2.mp3";
import newfile from "./assets/newfile.mp3";
import newfile2 from "./assets/newfile2.mp3";
import newfile3 from "./assets/newfile3.mp3";
import previewComplete from "./assets/previewComplete.mp3";
import random from "./assets/random.mp3";
import random1 from "./assets/random1.mp3";
import random2 from "./assets/random2.mp3";
import random3 from "./assets/random3.mp3";
import track from "./assets/track.mp3";
import useState1 from "./assets/useState1.mp3";
import useState2 from "./assets/useState2.mp3";

const calm = {
  ambientTrack: [track],
  defaultSound: [random1],
  randomSounds: [random, random1, random2, random3],
  eventSounds: {
    function: [function2, function0],
    previewReload: [previewComplete],
    newFile: [newfile, newfile2, newfile3],
    assign: [assign, assign1, assign3],
    openTag: [random, random1, random2, random3],
    reactState: [useState1, useState2],
  },
};

export default calm;
